"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const TabsSet_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/TabsSet.vue"));
const Tab_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Tab.vue"));
const AllIcon_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Entities/AllIcon.vue"));
let ElementTabs = class ElementTabs extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.active = this.modelValue;
    }
    get elements() {
        return this.bpe.categories.map(cat => ({
            id: cat.id,
            sh: (0, trans_1.trans)(`heatmap.viz.items.${cat.id}_sh`),
            long: (0, trans_1.trans)(`heatmap.viz.items.${cat.id}`),
        }));
    }
    onChangeValue() {
        this.active = this.modelValue;
    }
    switchElementTab(el) {
        this.active = el.id;
        this.$emit('update:modelValue', el.id);
        // @ts-ignore
        window.mixpanel.track('Switch Elements Tab', {
            tab: el.id
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: () => 'all' })
], ElementTabs.prototype, "modelValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ElementTabs.prototype, "bpe", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('modelValue')
], ElementTabs.prototype, "onChangeValue", null);
ElementTabs = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TabsSet: TabsSet_vue_1.default,
            Tab: Tab_vue_1.default,
            AllIcon: AllIcon_vue_1.default,
        }
    })
], ElementTabs);
exports.default = ElementTabs;
